import { faCommentAltEdit } from '@fortawesome/pro-regular-svg-icons'
import React from 'react'
import { useQuery } from 'react-query'
import { useOutletContext, useParams } from 'react-router-dom'
import { Column } from 'react-table'
import customerUserService from '../../services/customerUsersService'
import { CustomerUser } from '../../types/customer-user'

import EmptyContent from '../EmptyContent'
import ErrorPage from '../ErrorPage'
import Table from '../Table'
import TableSkeleton from '../TableSkeleton'

const Users = () => {
  const { customerId } = useParams<{ customerId: string }>()
  const { handleOpenUserDrawer } = useOutletContext<{ handleOpenUserDrawer: (user: CustomerUser) => void }>()

  const {
    data: customerUsers,
    isLoading,
    isError,
  } = useQuery(['customerUsers', customerId], () => customerUserService.getAllFromCustomerId({ id: customerId }))

  const columns = React.useMemo<Column<CustomerUser>[]>(
    () => [
      {
        Header: 'Name',
        accessor: ({ user }) => <p className="text-sm font-normal leading-5 text-gray-900">{user?.displayName}</p>,
      },
      {
        Header: 'Email',
        accessor: ({ user }) => user?.email,
      },
      {
        Header: 'Assigned Locations',
        accessor: ({ assignedPlaces }) =>
          assignedPlaces && assignedPlaces.length > 0 ? (
            <span style={{ maxWidth: 300 }} className="block truncate">
              {assignedPlaces.map(({ name }) => name).join(', ')}
            </span>
          ) : (
            '-'
          ),
      },
      {
        Header: 'Creation Date',
        accessor: ({ createdAt }) => new Date(createdAt).toLocaleDateString('en-GB'),
      },
      {
        Header: ' ',
        disableSortBy: true,
        accessor: (user) => (
          <button onClick={() => handleOpenUserDrawer(user)} className="text-link">
            View
          </button>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (isLoading) return <TableSkeleton headers={['Name', 'Email', 'Assigned Locations', 'Creation Date', ' ']} />

  if (isError || !customerUsers) {
    return (
      <ErrorPage
        title="Something went wrong!"
        text="We keep track of these errors, but feel free to contact us if refreshing doesn't fix things."
      />
    )
  }

  if (customerUsers.length === 0) {
    return (
      <div className="mt-32 flex h-full items-center justify-center">
        <EmptyContent
          title="No Users found."
          description="This Customer dont have any users, please assign one."
          icon={faCommentAltEdit}
        />
      </div>
    )
  }

  return (
    <div>
      <Table columns={columns} data={customerUsers} />
    </div>
  )
}

export default Users
